import { render, staticRenderFns } from "./TemplateOrderMultiAdd.vue?vue&type=template&id=41c660bf&scoped=true"
import script from "./TemplateOrderMultiAdd.vue?vue&type=script&lang=js"
export * from "./TemplateOrderMultiAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c660bf",
  null
  
)

export default component.exports